import React, {useContext, useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import IFrameWrapper from "../../components/IFrameWrapper";
import {ENTRY_PLAN, IFRAME_DOMAIN} from "../../utilities/Constants";
import CompanyTeamContext from "../../CompanyTeamContext";
import {Button} from "react-bootstrap";
import Loader from "../../components/utilities/Loader";

const TestWizard = (props) => {
    const company = useContext(CompanyTeamContext)
    const [loader, setLoader] = useState(true)


    useEffect(() => {
        if(company){
            document.title  = "Test Wizard - " + company.basicTitle
            return () => {
                document.title = company.basicTitle
            }
        }
    },[company])

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.[0] === 'iframeLoading') {
                setLoader(event.data[1]);
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);



    return (
        <>
            <Loader loader={loader}/>
            <IFrameWrapper showNav={false} width={"1145px"} src={IFRAME_DOMAIN+"/SmartTestsCreator.htm?ck="+encodeURIComponent(company.key)+(company.selectedLitePlan == ENTRY_PLAN ? "&s3=1" : "")} onLoad={() => setLoader(false)} />
        </>
    )
};

export default TestWizard;